import React, { PropsWithChildren } from 'react';
import { cn } from 'shared-components';
import { BCMShortTimeline } from './BCMShortTimeline';
import { BCMShortCloseButton } from './BCMShortCloseButton';

interface BCMShortWizardShellProps {
  /** 0 = Your Information, 1 = Business Details, 2 = Confirm. Drives the timeline highlight. */
  currentStepIndex: number;
  /** When true, hides the timeline + close button and switches the card to the animated gradient. */
  isSubmitting?: boolean;
  /** Hides the timeline even when not submitting — useful for the standalone landing page. */
  hideTimeline?: boolean;
}

// Outer chrome for every BCM-Short step. Mirrors Volt's
// BCMSignupWizard.tsx card/gradient/nav-label/close-button layout
// verbatim so the two products visually match.
export const BCMShortWizardShell: React.FC<PropsWithChildren<BCMShortWizardShellProps>> = ({
  currentStepIndex,
  isSubmitting = false,
  hideTimeline = false,
  children,
}) => {
  const showTimeline = !isSubmitting && !hideTimeline;

  return (
    <div className="min-h-screen p-[10px] relative z-10 w-full">
      <div
        className={cn(
          'border border-[#d5cec8] pt-[20px] rounded-[15px] shadow-[0px_0px_20px_0px_rgba(13,13,13,0.05)] w-full min-h-[calc(100vh-20px)] w640:h-[calc(100vh-20px)] w640:max-h-[calc(100vh-20px)] w640:overflow-y-auto no-scrollbar flex flex-col',
          {
            'bg-v2-card-gradient-to-scroll bg-[length:100%_200%] animate-scrollBgGradient': isSubmitting,
          }
        )}
        style={
          !isSubmitting ? { background: 'linear-gradient(180deg, #fff6f0 0%, #fff6f0 50%, #D5D973 100%)' } : undefined
        }
      >
        {showTimeline && <BCMShortTimeline currentStep={currentStepIndex} />}

        <div className="flex gap-[10px] items-center px-[10px] py-[10px] mx-[20px]">
          <div className="flex flex-1 gap-[5px] h-[14px] items-center overflow-clip">
            <div className="w-[10px] h-[10px] rounded-full bg-[#d5d973]" />
            <span className="font-condensed text-[12px] text-[#9e9e9e] uppercase leading-[1.2]">
              BUSINESS CREDIT MONITORING
            </span>
          </div>
          {!isSubmitting && <BCMShortCloseButton />}
        </div>

        <div className="flex-1 flex flex-col items-center justify-center px-[20px] pb-[40px] relative">
          <div className="w-full max-w-[592px] flex flex-col items-center relative z-10">{children}</div>
        </div>
      </div>
    </div>
  );
};
